import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { editPlanItem, tieAdToPlannedAd } from 'redux/modules/adsPlanner';
import OpenInNew from 'material-ui/svg-icons/action/open-in-new';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { AdPlanIframePreviewWrap } from 'containers';
import * as styles from './PlanTableRow.scss';
var PlanTableRow = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    user: state.auth.user,
    organization: state.organization.current,
    currentPlanId: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].currentPlanId : 1
  };
}, {
  editPlanItem: editPlanItem,
  tieAdToPlannedAd: tieAdToPlannedAd
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PlanTableRow, _Component);

  var _super = _createSuper(PlanTableRow);

  function PlanTableRow(props) {
    var _this;

    _classCallCheck(this, PlanTableRow);

    _this = _super.call(this, props);
    _this.state = {
      editMode: false,
      editAdId: props.ad && props.ad.createdFacebookAdId ? props.ad.createdFacebookAdId : null,
      editName: '',
      editBudget: '',
      savingBudget: false
    };
    return _this;
  }

  _createClass(PlanTableRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ad = _this$props.ad,
          editable = _this$props.editable;
      var reused = ad && ad.PreviousAdsPlannerAds && !!ad.PreviousAdsPlannerAds.length;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, editable && (this.props.user.isLikeableLocal || this.props.user.isPartner) && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.btnWrap, " ").concat(styles.iconWrap)
      }, this.state.editMode ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginBottom: 8
        },
        secondary: true,
        disabled: this.state.savingBudget,
        label: "Save",
        onClick: function onClick() {
          if (!isNaN(parseFloat(_this2.state.editBudget))) {
            _this2.setState({
              savingBudget: true
            });

            _this2.props.editPlanItem(_this2.props.organization.id, _this2.props.ad.id, {
              name: _this2.state.editName,
              budgetInCents: parseFloat(_this2.state.editBudget) * 100,
              createdFacebookAdId: _this2.state.editAdId && _this2.state.editAdId.length ? _this2.state.editAdId : null
            }).then(function () {
              _this2.setState({
                editMode: false,
                editName: '',
                editBudget: '',
                savingBudget: false
              }, function () {
                if (ad.createdFacebookAdId && parseInt(ad.createdFacebookAdId) !== parseInt(_this2.state.editAdId) || !ad.createdFacebookAdId && _this2.state.editAdId) {//       window.location.reload();
                }
              });
            });
          }
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.state.savingBudget,
        label: "Cancel",
        onClick: function onClick() {
          _this2.setState({
            editMode: false,
            editAdId: ad.createdFacebookAdId || null,
            editName: '',
            editBudget: '',
            savingBudget: false
          });
        }
      })) : /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.icon, " icon ion-edit"),
        onClick: function onClick() {
          return _this2.setState({
            editMode: true,
            editName: ad.name,
            editBudget: ad.budget / 100.0
          });
        }
      }), this.state.savingBudget && /*#__PURE__*/React.createElement("i", {
        style: {
          marginLeft: 12
        },
        className: "fa fa-circle-o-notch fa-spin"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.textWrap
      }, this.state.editMode ? /*#__PURE__*/React.createElement(TextField, {
        floatingLabelText: "Name",
        floatingLabelFixed: true,
        style: {
          marginRight: 40
        },
        value: this.state.editName,
        onChange: function onChange(e) {
          _this2.setState({
            editName: e.target.value
          });
        }
      }) : /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.textCol, " ").concat(styles.col2)
      }, ad.name), this.state.editMode && !this.props.pastMonth ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "$"), /*#__PURE__*/React.createElement(TextField, {
        floatingLabelText: "Budget",
        floatingLabelFixed: true,
        value: this.state.editBudget,
        onChange: function onChange(e) {
          _this2.setState({
            editBudget: e.target.value
          });
        }
      })) : /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.textCol, " ").concat(styles.col3)
      }, this.props.formatCurrency(ad.budget)), this.state.editMode && !this.props.pastMonth ? /*#__PURE__*/React.createElement(TextField, {
        floatingLabelText: "Ad Id",
        floatingLabelFixed: true,
        style: {
          marginRight: 40
        },
        placeholder: "Facebook Ad Id",
        value: this.state.editAdId,
        onChange: function onChange(e) {
          _this2.setState({
            editAdId: e.target.value
          });
        }
      }) : /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.textCol, " ").concat(styles.col2)
      }, "Ad Id: ", this.state.editAdId), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.textCol, " ").concat(styles.col4)
      }, this.state.editMode || ad.newAd ? '' : ad.result)), !this.state.editMode && !ad.createdFacebookAdId && !this.props.pastMonth && (this.props.user.isLikeableLocal || this.props.user.isPartner) ? /*#__PURE__*/React.createElement("div", {
        className: styles.trashWrap
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.icon, " icon ion-ios-trash-outline"),
        onClick: function onClick() {
          return _this2.props.handleDeletePlanItem(ad.id);
        }
      })) : /*#__PURE__*/React.createElement("div", {
        className: styles.trashWrap
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.icon)
      }, " ")));
    }
  }]);

  return PlanTableRow;
}(Component), _defineProperty(_class2, "defaultProps", {
  editable: false
}), _temp)) || _class);
export { PlanTableRow as default };